export default __webpack_public_path__ + "static/media/sharehighlight.da335914.svg";